import { gql } from "@apollo/client";
export const WINE_CUSTOM_UPDATE = gql `
  mutation WineCustomUpdate($input: WineCustomUpdateInput!) {
    WineCustomUpdate(input: $input)
  }
`;
